import { ActionTree } from 'vuex'
import { MealState, IMealState } from './state';
import { mealTypes } from './types';
import { SyncCommandResult, MealCountStatus, MealCountDto, SaveMealCountRequest } from '@/models';
import { MealCountDtoViewModel } from '@/view-models';
import { MergeServingLineRequest } from '@/models/meal-counts/serving-line';

export const mealActions: ActionTree<MealState, IMealState> = {
  async [mealTypes.actions.updateSyncDates]({ commit, state }, syncData: SyncCommandResult) {
    const syncedGuids = syncData.data.map(item => item.trackingGuid.toString());

    const counts = state.mealCountDtos
      .filter(mc => syncedGuids.includes(mc.trackingGuid));

    let syncDate:Date | null = null;

    for (let count of counts) {
      const syncResult = syncData.data.find(item => item.trackingGuid.toString() === count.trackingGuid)
      count.syncDateUtc = syncResult ? syncResult.syncDateUtc : null;
      syncDate = count.syncDateUtc;
    }

    commit(mealTypes.mutations.updateSyncDate, syncDate);
  },

  async [mealTypes.actions.updateCountStatus]({ commit }, status: MealCountStatus) {
    commit(mealTypes.mutations.updateCountStatus, status);
  },

  async [mealTypes.actions.updateCountStatuses]({ dispatch }, countStatuses: MealCountStatus[]) {
    for (let status of countStatuses) {
      await dispatch(mealTypes.actions.updateCountStatus, status);
    }
  },

  async [mealTypes.actions.updateCountDto]({ commit, state }, dto: MealCountDto) {
    commit(mealTypes.mutations.updateCountDto, dto);

    // updating a meal count needs to update it's status as well
    const vm = new MealCountDtoViewModel(dto);
    const c = vm.mealCounts;

    let status = state.mealCountStatuses.find(mcs =>
      mcs.programId === c.programId
      && mcs.siteId === c.siteId
      && mcs.mealTypeId === c.mealTypeId
      && mcs.mealServiceDate === c.mealServiceDate);

    const hasAffirmed = vm.affirmed;
    const hasDrafts = vm.tally.totalCountWithWaste > 0 && !vm.affirmed;
    if (status) {
      status.hasAffirmedRevisions = status.hasAffirmedRevisions || hasAffirmed;
      status.hasDraftRevisions = !vm.affirmed && (status.hasDraftRevisions || hasDrafts);
    }
    else {
      status = new MealCountStatus(c.programId, c.siteId, c.mealTypeId, c.mealServiceDate, true, hasAffirmed, hasDrafts);
    }

    commit(mealTypes.mutations.updateCountStatus, status);
  },

  async [mealTypes.actions.updateMultipleCountDtos]({ dispatch }, dtos: MealCountDto[]) {
    for (let dto of dtos) {
      await dispatch(mealTypes.actions.updateCountDto, dto);
    }
  },

  async [mealTypes.actions.updateRequestToSyncUp]({ commit }, request: SaveMealCountRequest) {
    commit(mealTypes.mutations.updateRequestToSyncUp, request);
  },

  async [mealTypes.actions.clearSyncUp]({ commit }) {
    commit(mealTypes.mutations.clearSyncUp);
  },

  async [mealTypes.actions.setTempDto]({ commit }, tempCount: MealCountDto) {
    commit(mealTypes.mutations.updateTempDto, tempCount);
  },

  async [mealTypes.actions.updateMergeServingLines]({ commit }, request: MergeServingLineRequest) {
    commit(mealTypes.mutations.updateMergeServingLines, request);
  },

  async [mealTypes.actions.clearServingLines]({ commit }) {
    commit(mealTypes.mutations.clearServingLines);
  }
};
